// Feature: Pages pages
// Common JS for pages pages

// Import JS for hero modal video
require('../components/_modal-video.js');
